import React from "react";
import { Link } from "react-router-dom";
import { Timer } from "lucide-react";

export function Logo({ className = "", showTagline = false }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
      <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm transition-transform group-hover:scale-105">
        <Timer className="h-5 w-5" strokeWidth={2.4} />
        <span className="absolute inset-0 rounded-xl ring-2 ring-primary/20" />
      </span>
      <span className="leading-none">
        <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
          EVER<span className="text-primary">MIN</span>
        </span>
        {showTagline && (
          <span className="block text-[11px] font-medium text-slate-500 mt-0.5">
            Make Every Minute Count.
          </span>
        )}
      </span>
    </Link>
  );
}
